import type { Segment } from "./arrangementStore";
import { useInstrumentStore } from "./instrumentStore";
import { getAudioEngine } from "../audio/AudioEngine";

function clone<T>(value: T): T {
  if (typeof globalThis.structuredClone === "function") {
    return globalThis.structuredClone(value);
  }
  return JSON.parse(JSON.stringify(value));
}

export function loadSegmentIntoEditor(segment: Segment): void {
  const engine = getAudioEngine();
  useInstrumentStore.setState((s) => ({
    ...s,
    bpm: segment.bpm,
    pattern: clone(segment.pattern),
    melodyGrids: clone(segment.melodyGrids),
    fx: clone(segment.fx),
    trackMutes: clone(segment.trackMutes),
    drumMutes: clone(segment.drumMutes),
    subdivisions: clone(segment.subdivisions),
    rootPitch: segment.rootPitch,
    blueFlat3: segment.blueFlat3,
    blueFlat5: segment.blueFlat5,
  }));
  // Re-apply the non-reactive parts of the audio graph so the loaded state is audible live.
  engine.setBpm(segment.bpm);
  (["drums", "keys", "bass", "lead"] as const).forEach((track) => {
    const fx = segment.fx[track];
    engine.setFx(track, "volume", fx.volume);
    engine.setFx(track, "fuzz", fx.fuzz);
    engine.setFx(track, "delay", fx.delay);
    engine.setFx(track, "reverb", fx.reverb);
    engine.setFx(track, "decay", fx.decay);
  });
}
